import { proxyClientInstance } from "../../wrappers/client";

export const getFeocsSurveyLink = (irn) => {
    const getUrl = `/api/faculty/v1/integrations/fms/feocsInvitations?irn=${irn}`;
    return proxyClientInstance.get(getUrl);
  };